<h1 mat-dialog-title>Términos de Uso</h1>
<mat-dialog-content class="mat-typography">
    <h5>INTRODUCCIÓN</h5>
    <p>Bienvenido al portal de facturación de NTLINK. Este aviso de uso de datos y privacidad tiene como objetivo
        informarle cómo manejamos y utilizamos sus datos personales, así como también proporcionar información
        importante acerca de sus derechos de privacidad.</p>
    <p>Este aviso se aplica a la información personal que recopilamos a través de nuestro portal de facturación y cómo
        utilizamos esta información. Al utilizar nuestro portal de facturación, usted acepta y da su consentimiento a
        los términos y condiciones descritos en este aviso.</p>

    <h5>INFORMACIÓN PERSONAL QUE RECOPILAMOS</h5>
    <p>Recopilamos información personal que nos proporciona cuando se registra en nuestro portal de facturación o cuando
        utiliza nuestros servicios. Esta información puede incluir su nombre, dirección de correo electrónico, número de
        teléfono, dirección de facturación, información de pago y cualquier otra información que nos proporcione.</p>
    <p>Además, podemos recopilar automáticamente información sobre cómo utiliza nuestro portal de facturación, como su
        dirección IP, el tipo de navegador que está utilizando, su sistema operativo, su proveedor de servicios de
        Internet y la información de cookies.</p>

    <h5>CÓMO UTILIZAMOS SU INFORMACIÓN PERSONAL</h5>
    <p>Utilizamos la información personal que recopilamos para proporcionarle los servicios que ha solicitado a través
        de nuestro portal de facturación, para administrar su cuenta y para comunicarnos con usted acerca de su cuenta o
        de los servicios que le proporcionamos.</p>
    <p>También podemos utilizar su información personal para fines de marketing y para mejorar nuestros servicios.
        Podemos utilizar la información que recopilamos automáticamente para personalizar su experiencia en nuestro
        portal de facturación y para mejorar nuestro sitio web.</p>

    <h5>CÓMO COMPARTIMOS SU INFORMACIÓN PERSONAL</h5>
    <p>Podemos compartir su información personal con terceros proveedores de servicios que nos ayudan a proporcionar los
        servicios que le ofrecemos a través de nuestro portal de facturación. Estos proveedores de servicios pueden
        incluir procesadores de pagos, empresas de envío y proveedores de servicios de correo electrónico.</p>
    <p>También podemos divulgar su información personal si creemos que es necesario hacerlo para cumplir con la ley
        aplicable, para hacer cumplir nuestros términos y condiciones, para proteger nuestros derechos, propiedad o
        seguridad, o para proteger la seguridad de nuestros usuarios u otros.</p>

    <h5>TRANSFERENCIA INTERNACIONAL DE DATOS</h5>
    <p>Podemos transferir su información personal a países fuera de México, incluidos aquellos que no ofrecen un nivel
        adecuado de protección de datos. Sin embargo, tomaremos las medidas necesarias para garantizar que cualquier
        transferencia de datos se realice de conformidad con la legislación aplicable.</p>

    <h5>CÓMO PROTEGEMOS SU INFORMACIÓN PERSONAL</h5>
    <p>Tomamos medidas de seguridad razonables para proteger su información personal contra el acceso no autorizado, la
        alteración, divulgación o destrucción. Sin embargo, ninguna transmisión de datos por Internet puede garantizar
        la seguridad completa.</p>

    <h5>COOKIES</h5>
    <p>Utilizamos cookies para recopilar información sobre cómo utiliza nuestro portal de facturación. Las cookies son
        pequeños archivos de texto que se almacenan en su dispositivo y nos permiten reconocer su dispositivo la próxima
        vez que nos visite.</p>

    <h5>CONSENTIMIENTO Y ACCESO</h5>
    <p>Al utilizar nuestro portal de facturación, usted acepta y da su consentimiento a los términos y condiciones
        descritos en este aviso de uso de datos y privacidad. Si no está de acuerdo con estos términos y condiciones, no
        utilice nuestro portal de facturación.</p>
    <p>Tiene derecho a acceder y actualizar su información personal que tenemos en nuestro poder. Si desea acceder o
        actualizar su información personal, comuníquese con nosotros utilizando la información de contacto que se
        proporciona al final de este aviso.</p>

    <h5>DERECHOS DE PRIVACIDAD</h5>
    <p>Usted tiene ciertos derechos de privacidad en relación con su información personal que recopilamos y utilizamos.
        Estos derechos pueden incluir el derecho a:</p>
    <p>Acceder a su información personal y recibir una copia de los datos que tenemos en nuestro poder.</p>
    <p>• Corregir cualquier información personal que sea inexacta o incompleta.</p>
    <p>• Eliminar su información personal de nuestros registros.</p>
    <p>• Restringir el procesamiento de su información personal.</p>
    <p>• Oponerse al procesamiento de su información personal con fines de marketing directo.</p>

    <h5>RESPONSABILIDAD LEGAL</h5>
    <p>NTLINK se deslinda de cualquier acusación legal que el usuario pueda ejercer en contra de la compañía. El usuario
        acepta que NTLINK no será responsable por ningún daño directo, indirecto, incidental, especial o consecuente que
        surja del uso o la imposibilidad de utilizar nuestro portal de facturación.</p>

    <h5>MODIFICACIONES AL AVISO DE USO DE DATOS Y PRIVACIDAD</h5>
    <p>Nos reservamos el derecho de modificar este aviso de uso de datos y privacidad en cualquier momento y sin previo
        aviso. Se le recomienda que revise periódicamente este aviso para conocer las últimas actualizaciones.</p>
    <p>En fe de lo cual, al hacer clic en "Acepto" o al utilizar nuestro portal de facturación, usted acepta y da su
        consentimiento a los términos y condiciones descritos en este aviso de uso de datos y privacidad.</p>

    <h5>CONTACTO</h5>
    <p>Si tiene alguna pregunta o inquietud acerca de este aviso de uso de datos y privacidad, o si desea acceder o
        actualizar su información personal, comuníquese con nosotros a través de la siguiente información de contacto:
    </p>
    <p>NTLINK COMUNICACIONES SA DE CV</p>
    <p>Correo electrónico:</p>
    <p>• ventas&#64;ntlink.com.mx</p>
    <p>• soporte_tecnico&#64;ntlink.com.mx</p>
    <p>Teléfono:</p>
    <p>• +(55) 47 80 02 00 • +(55) 62 72 55 49 • +(55) 62 72 55 50</p>
    <p>• +(55) 82 50 76 56</p>

    <h5>POLÍTICA DE COOKIES</h5>
    <p>Utilizamos cookies en nuestro portal de facturación para mejorar su experiencia de navegación y para recopilar
        información sobre cómo utiliza nuestro sitio. Esta política de cookies describe qué son las cookies, cómo las
        utilizamos y sus opciones con respecto a su uso de cookies.</p>

    <h5>¿Qué son las cookies?</h5>
    <p>Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro portal de
        facturación. Las cookies nos permiten recordar sus preferencias y personalizar su experiencia en nuestro sitio
        web.</p>

    <h5>¿Cómo utilizamos las cookies?</h5>
    <p>Utilizamos cookies para los siguientes propósitos:</p>
    <p>Mejorar la funcionalidad de nuestro portal de facturación.</p>
    <p>Personalizar su experiencia de navegación en nuestro sitio web.</p>
    <p>Recopilar información estadística sobre el uso de nuestro sitio web.</p>
    <p>Publicidad y marketing personalizado.</p>
    <p>Protección contra fraudes y abusos.</p>

    <h5>¿Qué tipos de cookies utilizamos?</h5>
    <p>Utilizamos cookies propias y de terceros en nuestro portal de facturación. Las cookies propias son aquellas que
        establecemos nosotros, mientras que las cookies de terceros son aquellas que se establecen por un tercero cuando
        visita nuestro sitio web.</p>
    <p>Las cookies pueden ser persistentes o de sesión. Las cookies persistentes permanecen en su dispositivo durante un
        período de tiempo determinado, mientras que las cookies de sesión se eliminan automáticamente cuando cierra su
        navegador.</p>

    <h5>¿Cómo puede controlar el uso de cookies?</h5>
    <p>Usted puede controlar el uso de cookies a través de la configuración de su navegador. La mayoría de los
        navegadores web le permiten administrar sus preferencias de cookies a través de la configuración del navegador.
        Sin embargo, tenga en cuenta que la desactivación de las cookies puede afectar la funcionalidad de nuestro sitio
        web.</p>

    <h5>CONCLUSIÓN</h5>
    <p>En NTLINK, nos tomamos muy en serio la privacidad y seguridad de sus datos personales. Esperamos que este aviso
        de uso de datos y privacidad y nuestra política de cookies le hayan proporcionado información clara y detallada
        sobre cómo manejamos y utilizamos su información personal en nuestro portal de facturación.</p>
    <p>Si tiene alguna pregunta o inquietud acerca de este aviso, comuníquese con nosotros utilizando la información de
        contacto que se proporciona en la parte 6.</p>

    <h5>USO Y MANEJO DE SUS DATOS PERSONALES</h5>
    <p>En NTLINK, nos comprometemos a proteger su privacidad y sus datos personales. Para ofrecerle nuestros servicios
        de facturación electrónica, es necesario que recopilemos y utilicemos cierta información personal. Esta parte
        del aviso de uso de datos y privacidad describe cómo manejamos y utilizamos su información personal en nuestro
        portal de facturación.</p>

    <h5>¿Qué información personal recopilamos y utilizamos?</h5>
    <p>Recopilamos y utilizamos la siguiente información personal cuando utiliza nuestro portal de facturación:</p>
    <p>Información de identificación: incluye su nombre, dirección, número de identificación fiscal y otra información
        de identificación similar.</p>
    <p>Información de contacto: incluye su dirección de correo electrónico, número de teléfono y otra información de
        contacto similar.</p>
    <p>Información financiera: incluye información sobre sus transacciones y pagos en nuestro portal de facturación.</p>
    <p>Información de uso: incluye información sobre cómo utiliza nuestro portal de facturación.</p>

    <h5>¿Cómo utilizamos su información personal?</h5>
    <p>Utilizamos su información personal para los siguientes propósitos:</p>
    <p>Procesar y enviar facturas electrónicas.</p>
    <p>Verificar su identidad y autenticar su cuenta.</p>
    <p>Comunicarnos con usted sobre el estado de sus facturas.</p>
    <p>Brindarle soporte técnico y atención al cliente.</p>
    <p>Mejorar la funcionalidad de nuestro portal de facturación.</p>
    <p>Cumplir con nuestras obligaciones legales y reglamentarias.</p>

    <h5>¿Con quién compartimos su información personal?</h5>
    <p>Compartimos su información personal con los siguientes terceros:</p>
    <p>Proveedores de servicios: utilizamos proveedores de servicios para ayudarnos a procesar y enviar facturas
        electrónicas.</p>
    <p>Autoridades fiscales: podemos divulgar su información personal a las autoridades fiscales en cumplimiento de
        nuestras obligaciones legales y reglamentarias.</p>
    <p>Terceros autorizados por usted: podemos compartir su información personal con terceros autorizados por usted para
        recibir sus facturas electrónicas.</p>
    <p>En todos los casos, nos aseguramos de que nuestros terceros proveedores de servicios y autoridades fiscales
        mantengan la confidencialidad y seguridad de su información personal.</p>

    <h5>¿Cómo protegemos su información personal?</h5>
    <p>En NTLINK, tomamos medidas de seguridad técnicas, administrativas y físicas razonables para proteger su
        información personal contra el acceso no autorizado, la divulgación y el uso indebido. También nos aseguramos de
        que nuestros terceros proveedores de servicios cumplan con las mismas medidas de seguridad.</p>

    <h5>¿Durante cuánto tiempo conservamos su información personal?</h5>
    <p>Conservamos su información personal durante el tiempo que sea necesario para cumplir con nuestras obligaciones
        legales y reglamentarias y para proporcionarle nuestros servicios de facturación electrónica.</p>
    <p>En fe de lo cual, al utilizar nuestro portal de facturación, usted acepta y da su consentimiento a los términos y
        condiciones descritos en este aviso de uso de datos y privacidad.</p>

    <h5>LIMITACIÓN DE RESPONSABILIDAD</h5>
    <p>En NTLINK, nos esforzamos por ofrecer un portal de facturación electrónico seguro y confiable. Sin embargo, en
        caso de que surja alguna controversia o reclamo en relación con el manejo o uso de su información personal en
        nuestro portal de facturación, nos deslindamos de cualquier responsabilidad legal.</p>
    <p>Usted reconoce y acepta que NTLINK no será responsable por cualquier daño, pérdida, costo o gasto, incluyendo,
        pero no limitado a daños directos, indirectos, consecuentes, especiales o punitivos, relacionados con el uso de
        su información personal en nuestro portal de facturación.</p>
    <p>En caso de que tenga alguna controversia o reclamo relacionado con el manejo o uso de su información personal en
        nuestro portal de facturación, se compromete a indemnizar y eximir de responsabilidad a NTLINK y sus
        funcionarios, directores, empleados y agentes de cualquier reclamo, demanda o acción legal, incluyendo los
        costos razonables de abogados, relacionados con dicha controversia o reclamo.</p>

    <h5>CONTACTO</h5>
    <p>Si tiene alguna pregunta o inquietud acerca de este aviso de uso de datos y privacidad, comuníquese con nosotros
        a través de la información de contacto proporcionada a continuación:</p>
    <p>NTLINK COMUNICACIONES SA DE CV</p>
    <p>Correo electrónico:</p>
    <p>• ventas&#64;ntlink.com.mx</p>
    <p>• soporte_tecnico&#64;ntlink.com.mx</p>
    <p>Teléfono:</p>
    <p>• +(55) 47 80 02 00 • +(55) 62 72 55 49 • +(55) 62 72 55 50</p>
    <p>• +(55) 82 50 76 56</p>
    <p>Al utilizar nuestro portal de facturación, usted acepta y da su consentimiento a los términos y condiciones
        descritos en este aviso de uso de datos y privacidad. Por favor, revise este documento regularmente para estar
        al tanto de cualquier cambio o actualización.</p>

    <h5>CAMBIOS EN ESTE AVISO</h5>
    <p>Nos reservamos el derecho de modificar o actualizar este aviso de uso de datos y privacidad en cualquier momento.
        Cualquier cambio entrará en vigencia inmediatamente después de su publicación en nuestro portal de facturación.
        Si realizamos cambios significativos en este aviso, le notificaremos a través de la dirección de correo
        electrónico que nos proporcionó al registrarse en nuestro portal de facturación.</p>
    <p>Continuar utilizando nuestro portal de facturación después de la publicación de cualquier cambio o actualización
        en este aviso de uso de datos y privacidad constituirá su aceptación de dichos cambios o actualizaciones. Por lo
        tanto, le recomendamos que revise regularmente este aviso para estar al tanto de cualquier cambio o
        actualización.</p>

    <h5>LEY APLICABLE Y JURISDICCIÓN</h5>
    <p>Este aviso de uso de datos y privacidad se regirá e interpretará de acuerdo con las leyes de México. Cualquier
        controversia o reclamo relacionado con este aviso o su violación será resuelto por los tribunales de la Ciudad
        de México, renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o
        futuro.</p>

    <h5>CONSENTIMIENTO</h5>
    <p>Al utilizar nuestro portal de facturación, usted acepta y da su consentimiento a los términos y condiciones
        descritos en este aviso de uso de datos y privacidad. Si no está de acuerdo con estos términos y condiciones, le
        recomendamos que no utilice nuestro portal de facturación.</p>

    <h5>CONCLUSIÓN</h5>
    <p>En NTLINK, nos tomamos muy en serio la privacidad y seguridad de sus datos personales. Esperamos que este aviso
        de uso de datos y privacidad le haya proporcionado información clara y detallada sobre cómo manejamos y
        utilizamos su información personal en nuestro portal de facturación.</p>
    <p>Si tiene alguna pregunta o inquietud acerca de este aviso, comuníquese con nosotros utilizando la información de
        contacto que se proporciona en la parte 6.</p>
    <p>Al utilizar nuestro portal de facturación, usted acepta y da su consentimiento a los términos y condiciones
        descritos en este aviso de uso de datos y privacidad. Por favor, revise este documento regularmente para estar
        al tanto de cualquier cambio o actualización.</p>

    <h5>RESPONSABILIDAD DEL USUARIO</h5>
    <p>Al utilizar nuestro portal de facturación, usted es responsable de mantener la confidencialidad de su información
        de inicio de sesión y de cualquier actividad que se realice en su cuenta. Además, se compromete a no utilizar
        nuestro portal de facturación para ninguna actividad ilegal o fraudulenta.</p>
    <p>Si sospechamos o tenemos conocimiento de cualquier actividad ilegal o fraudulenta en su cuenta, nos reservamos el
        derecho de suspender o cancelar su cuenta, así como de informar a las autoridades competentes sobre cualquier
        actividad sospechosa.</p>
    <p>También es su responsabilidad asegurarse de que la información que nos proporciona es precisa y actualizada. Si
        su información de contacto cambia, debe actualizarla en su cuenta de inmediato.</p>
    <p>En caso de que se le solicite información personal adicional, como su número de identificación fiscal o cualquier
        otra información necesaria para completar una transacción en nuestro portal de facturación, se compromete a
        proporcionar dicha información de manera precisa y completa.</p>
    <p>Al utilizar nuestro portal de facturación, acepta y reconoce que NTLINK no será responsable por ninguna pérdida,
        daño o costo, incluyendo pero no limitado a daños directos, indirectos, consecuentes, especiales o punitivos,
        relacionados con cualquier actividad ilegal o fraudulenta en su cuenta.</p>

    <h5>LIMITACIÓN DE RESPONSABILIDAD</h5>
    <p>En ningún caso NTLINK será responsable por ninguna pérdida, daño o costo, incluyendo pero no limitado a daños
        directos, indirectos, consecuentes, especiales o punitivos, relacionados con el uso o la imposibilidad de usar
        nuestro portal de facturación, incluso si se nos ha informado previamente de la posibilidad de dichos daños.</p>
    <p>En caso de cualquier disputa entre usted y otro usuario de nuestro portal de facturación, acepta y reconoce que
        NTLINK no será responsable por ninguna pérdida, daño o costo relacionado con dicha disputa.</p>
    <p>NTLINK no será responsable por ninguna interrupción en el servicio, error, omisión, interrupción, eliminación,
        defecto, retraso en la operación o transmisión, falla en la línea de comunicación, robo o destrucción o acceso
        no autorizado o alteración de cualquier información, incluyendo pero no limitado a información personal.</p>
    <p>En la medida máxima permitida por la ley, renunciamos a cualquier responsabilidad por cualquier pérdida, daño o
        costo causado por virus o cualquier otra forma de código malicioso que pueda infectar su equipo o cualquier otro
        equipo relacionado con el uso de nuestro portal de facturación.</p>
    <p>NTLINK no será responsable por cualquier falla en el cumplimiento de estos términos y condiciones si dicha falla
        es causada por eventos más allá de nuestro control razonable, incluyendo pero no limitado a fallas en la red de
        Internet, fallas de energía o cualquier desastre natural o acto de guerra.</p>

    <h5>TERMINACIÓN</h5>
    <p>NTLINK se reserva el derecho de terminar su acceso a nuestro portal de facturación en cualquier momento y sin
        previo aviso, si incumple cualquiera de los términos y condiciones descritos en este aviso de uso de datos y
        privacidad.</p>
    <p>En caso de que su acceso a nuestro portal de facturación sea terminado, se le notificará por correo electrónico a
        la dirección de correo electrónico que proporcionó al registrarse en nuestro portal de facturación.</p>
    <p>En caso de terminación, todas las disposiciones de este aviso de uso de datos y privacidad que por su naturaleza
        deban sobrevivir a la terminación, incluyendo, pero no limitado a las secciones de propiedad intelectual,
        indemnización, limitación de responsabilidad y ley aplicable y jurisdicción, sobrevivirán a dicha terminación.
    </p>

    <h5>DIVISIBILIDAD</h5>
    <p>Si alguna disposición de este aviso de uso de datos y privacidad se considera inválida o no aplicable por un
        tribunal de jurisdicción competente, dicha disposición se considerará separable de este aviso y las
        disposiciones restantes seguirán siendo válidas y aplicables en la medida máxima permitida por la ley.</p>
    <p>Si alguna disposición de este aviso de uso de datos y privacidad se considera inválida o no aplicable por
        cualquier otra razón, dicha disposición se considerará modificada en la medida necesaria para hacerla válida y
        aplicable, y las disposiciones restantes seguirán siendo válidas y aplicables en la medida máxima permitida por
        la ley.</p>

    <h5>CAMBIOS AL AVISO DE USO DE DATOS Y PRIVACIDAD</h5>
    <p>Nos reservamos el derecho de modificar o actualizar este aviso de uso de datos y privacidad en cualquier momento
        y sin previo aviso, a nuestra entera discreción. Le recomendamos que revise este aviso periódicamente para estar
        al tanto de cualquier cambio o actualización.</p>
    <p>Si realizamos cambios significativos a este aviso de uso de datos y privacidad, le notificaremos publicando un
        aviso destacado en nuestro portal de facturación y actualizando la fecha de "Última actualización" en la parte
        superior de este documento.</p>
    <p>Si continúa utilizando nuestro portal de facturación después de que se hayan realizado cambios en este aviso de
        uso de datos y privacidad, se considerará que ha aceptado dichos cambios. Si no está de acuerdo con los cambios,
        deberá dejar de utilizar nuestro portal de facturación de inmediato.</p>




    <h1>CONTRATO DE USO DEL PORTAL NTLINK</h1>

    <div class="section">
        <h3>Parte 1: Aceptación de los términos y condiciones</h3>
        <p>Al hacer clic en el botón "Aceptar" o al utilizar el Portal NTLINK, el usuario registrado acepta de manera
            implícita todos los términos y condiciones establecidos en este Contrato de uso del portal NTLINK. La
            aceptación de estos términos y condiciones es un requisito previo para acceder y utilizar el Portal NTLINK.
        </p>
        <p>El usuario registrado reconoce que ha leído y comprendido este Contrato en su totalidad y está de acuerdo con
            todas las disposiciones establecidas en él. Asimismo, el usuario registrado manifiesta que tiene la
            capacidad legal para aceptar este Contrato y utilizar el Portal NTLINK.</p>
        <p>La aceptación de este Contrato implica el compromiso de cumplir con todas las obligaciones y
            responsabilidades establecidas en el presente documento. En caso de no estar de acuerdo con alguno de los
            términos y condiciones aquí estipulados, el usuario registrado deberá abstenerse de utilizar el Portal
            NTLINK.</p>
        <p>El usuario registrado también reconoce que NTLINK se reserva el derecho de modificar este Contrato en
            cualquier momento. Cualquier modificación será notificada al usuario registrado a través del Portal NTLINK o
            por otros medios de comunicación proporcionados por NTLINK. El uso continuado del Portal NTLINK después de
            la notificación de las modificaciones implicará la aceptación de estas.</p>
        <p>Acepto los términos y condiciones establecidos en este Contrato al hacer clic en el botón "Aceptar".</p>
    </div>

    <div class="section">
        <h3>Parte 2: Descripción del Portal NTLINK</h3>
        <p>El Portal NTLINK es una plataforma en línea que permite a los usuarios registrados emitir Comprobantes
            Fiscales Digitales por Internet (CFDI) de ingreso, egreso y complemento de pagos, de acuerdo con la versión
            vigente emitida por el Servicio de Administración Tributaria (SAT) de México.</p>
        <p>El Portal NTLINK ofrece a los usuarios registrados las siguientes funcionalidades:</p>
        <p>a) Emisión de CFDI de ingreso, egreso y complemento de pagos, sin adendas, conforme a la versión de CFDI
            vigente emitida por el SAT.</p>
        <p>b) Posibilidad de cargar los archivos .cer y .key en el portal para su uso en la generación de los CFDI.</p>
        <p>c) Registro de los datos del contribuyente emisor necesarios para la generación del CFDI.</p>
        <p>d) Validación y certificación del documento digital que ampara el comprobante fiscal.</p>
        <p>e) Entrega del CFDI certificado al contribuyente emisor, o acuse de rechazo en caso de no cumplir con los
            requisitos establecidos por el SAT.</p>
        <p>f) Almacenamiento de los comprobantes fiscales emitidos en el portal, permitiendo su consulta por un período
            mínimo de 3 meses a partir de la fecha de certificación.</p>
        <p>g) Servicio de atención para atender quejas y solicitudes de soporte, asegurando una respuesta en un plazo
            máximo de 2 horas y una resolución en un plazo máximo de 8 horas, en casos especiales de segundo o tercer
            nivel, la resolución máxima será de 24 hs.</p>
        <p>h) Disponibilidad del servicio con un mínimo del 99.3% del tiempo.</p>
        <p>El Portal NTLINK está diseñado para facilitar la emisión de CFDI y proporcionar un medio seguro y confiable
            para el cumplimiento de las obligaciones fiscales de los contribuyentes registrados.</p>
    </div>

    <div class="section">
        <h3>Parte 3: Responsabilidades de NTLINK</h3>
        <p>3.1 Responsabilidades del Portal NTLINK: NTLINK se compromete a proporcionar y asegurar las siguientes
            funcionalidades dentro del Portal NTLINK:</p>
        <p>a) Emisión de CFDI de ingreso, egreso y complemento de pagos, sin adendas; conforme a la versión de CFDI
            vigente emitida por el SAT.</p>
        <p>b) Posibilidad de cargar los archivos .cer y .key en el portal.</p>
        <p>c) Registro de datos del contribuyente emisor previo a la generación del CFDI.</p>
        <p>d) Validación y certificación del documento digital que ampara el comprobante fiscal.</p>
        <p>e) Entrega de CFDI certificado al contribuyente emisor, o acuse de rechazo.</p>
        <p>f) Almacenamiento de comprobantes para consulta por un período mínimo de 3 meses a partir de la fecha de
            certificación.</p>
        <p>g) Servicio de atención de quejas y solicitudes de soporte, sujeto a los días y horarios establecidos, con un
            tiempo de respuesta de máximo 2 horas y una resolución en un plazo de 8 horas, en casos especiales de
            segundo o tercer nivel, la resolución máxima será de 24 horas. El soporte técnico de primer nivel estará
            disponible en días hábiles, en horario de 9:00 a 18:00 hrs (hora del centro de México), salvo que se
            establezca lo contrario por escrito.</p>
        <p>h) Disponibilidad del servicio con un nivel mínimo del 99.3%.</p>
        <p>3.2 Número de timbres para emisión de facturas: El número de timbres disponibles para la emisión de facturas
            a través del Portal NTLINK estará sujeto a la decisión de NTLINK en el momento del alta del usuario. Dicho
            número de timbres podrá variar según las fechas, promociones u otras circunstancias determinadas por NTLINK.
            Se aclara que NTLINK no se encuentra obligado a establecer un número mínimo o máximo de timbres para la
            emisión de facturas.</p>
        <p>NTLINK se compromete a hacer sus mejores esfuerzos para mantener las funcionalidades mencionadas disponibles
            en el Portal NTLINK, siempre sujeto a las disposiciones legales y normativas aplicables.</p>
        <p>3.3 Vigencia de timbres. El número de timbres asignados al usuario registrado estará sujeto a condiciones
            comerciales específicas. NTLink se reserva el derecho de establecer periodos de vigencia para el uso de los
            timbres asignados, incluyendo, de forma enunciativa mas no limitativa, la expiración automática de timbres
            que no hayan sido utilizados dentro de los 18 meses siguientes a su asignación, o cuando se detecte un
            periodo de inactividad mayor a 12 meses en la cuenta correspondiente.</p>
    </div>

    <div class="section">
        <h3>Parte 4: Obligaciones del usuario registrado</h3>
        <p>4.1 Uso adecuado del Portal NTLINK: El usuario registrado se compromete a utilizar el Portal NTLINK de manera
            adecuada, respetando todas las leyes, regulaciones y normas aplicables. Se abstendrá de utilizar el Portal
            NTLINK para actividades ilegales, fraudulentas, difamatorias, ofensivas, obscenas o que violen los derechos
            de terceros.</p>
        <p>4.2 Protección de las credenciales de acceso: El usuario registrado será el único responsable de mantener la
            confidencialidad y seguridad de sus credenciales de acceso al Portal NTLINK. Se compromete a no divulgar ni
            compartir sus credenciales con terceros, asumiendo la responsabilidad por cualquier uso no autorizado de su
            cuenta, NTLINK no tiene acceso a dicha información y, por tanto, no asume responsabilidad por su uso
            indebido.</p>
        <p>4.3 Veracidad de la información proporcionada: El usuario registrado garantiza que toda la información
            proporcionada durante el registro en el Portal NTLINK es veraz, completa y actualizada. Se compromete a
            informar a NTLINK de cualquier cambio o actualización en sus datos personales de manera oportuna.</p>
        <p>4.4 Uso de los servicios y contenidos: El usuario registrado utilizará los servicios y contenidos del Portal
            NTLINK únicamente para los fines permitidos y de acuerdo con las instrucciones proporcionadas por NTLINK.
            Queda expresamente prohibido copiar, reproducir, distribuir, modificar o explotar de cualquier forma los
            servicios y contenidos del Portal NTLINK sin autorización previa y por escrito de NTLINK.</p>
        <p>4.5 Cumplimiento de obligaciones fiscales: El usuario registrado se compromete a cumplir con todas las
            obligaciones fiscales y legales aplicables en relación con la emisión y gestión de los comprobantes fiscales
            digitales. Reconoce y acepta que NTLINK no asume ninguna responsabilidad por el incumplimiento de dichas
            obligaciones por parte del usuario registrado.</p>
    </div>

    <div class="section">
        <h3>Parte 5: Modificaciones al Portal NTLINK</h3>
        <p>5.1 Actualizaciones y mejoras: NTLINK se reserva el derecho de realizar modificaciones, actualizaciones o
            mejoras al Portal NTLINK en cualquier momento y sin previo aviso. Estas modificaciones pueden incluir
            cambios en la interfaz, funcionalidades, características o cualquier otro aspecto del Portal NTLINK.</p>
        <p>5.2 Notificaciones de cambios: NTLINK hará sus mejores esfuerzos para informar al usuario registrado sobre
            cualquier modificación importante en el Portal NTLINK a través de medios de comunicación apropiados, como
            notificaciones en el propio portal, correos electrónicos u otros medios disponibles. Sin embargo, el usuario
            registrado reconoce y acepta que es su responsabilidad estar al tanto de los cambios realizados en el Portal
            NTLINK.</p>
        <p>5.3 Aceptación de las modificaciones: El uso continuado del Portal NTLINK por parte del usuario registrado
            después de la implementación de cualquier modificación se considerará como una aceptación de dichas
            modificaciones. En caso de que el usuario registrado no esté de acuerdo con las modificaciones, podrá dar
            por terminado este Contrato de conformidad con las disposiciones establecidas en la Parte 8.</p>
        <p>NTLINK se esforzará en asegurar un funcionamiento óptimo y eficiente del Portal NTLINK, pero no garantiza la
            ausencia de errores, interrupciones, demoras u otros problemas técnicos que puedan afectar su disponibilidad
            o funcionamiento.</p>
    </div>

    <div class="section">
        <h3>Parte 6: Propiedad intelectual</h3>
        <p>6.1 Derechos de propiedad: El usuario registrado reconoce y acepta que NTLINK es el legítimo titular de todos
            los derechos de propiedad intelectual relacionados con el Portal NTLINK, incluyendo, pero no limitado a,
            marcas registradas, derechos de autor, patentes y know-how.</p>
        <p>6.2 Uso limitado: NTLINK otorga al usuario registrado un derecho limitado, no exclusivo, intransferible y
            revocable para utilizar el Portal NTLINK de acuerdo con los términos y condiciones establecidos en este
            Contrato. Este derecho no otorga al usuario registrado ninguna propiedad o derechos de propiedad intelectual
            sobre el Portal NTLINK.</p>
        <p>6.3 Restricciones (de forma enunciativa, más no limitativa): Queda expresamente prohibido al usuario
            registrado copiar, modificar, distribuir, transmitir, exhibir, reproducir, publicar, sublicenciar, crear
            trabajos derivados, descompilar, realizar ingeniería inversa, así como cualquier otro uso indebido o
            utilizar cualquier otra forma de explotación del Portal NTLINK sin el consentimiento previo y por escrito de
            NTLINK.</p>
        <p>6.4 Protección de derechos: El usuario registrado se compromete a no infringir los derechos de propiedad
            intelectual de NTLINK ni de terceros en relación con el uso del Portal NTLINK. En caso de que el usuario
            registrado tenga conocimiento de cualquier infracción o uso no autorizado, deberá notificarlo inmediatamente
            a NTLINK.</p>
    </div>

    <div class="section">
        <h3>Parte 7: Limitación de responsabilidad</h3>
        <p>7.1 Exclusión de garantías: El usuario registrado reconoce y acepta que el uso del Portal NTLINK se realiza
            bajo su propio riesgo. NTLINK no garantiza que el Portal NTLINK sea libre de errores, que funcione de manera
            ininterrumpida o esté libre de virus u otros componentes dañinos. El Portal NTLINK se proporciona "tal cual"
            y NTLINK no otorga ninguna garantía, expresa o implícita, incluyendo, pero no limitado a, garantías de
            comerciabilidad, idoneidad para un propósito particular y no infracción.</p>
        <p>7.2 Limitación de responsabilidad: En ningún caso NTLINK será responsable ante el usuario registrado por
            cualquier daño directo, indirecto, incidental, consecuente, especial o ejemplar que pueda surgir del uso o
            la imposibilidad de uso del Portal NTLINK, incluso si se ha advertido a NTLINK de la posibilidad de tales
            daños. Esta limitación de responsabilidad se aplicará en la medida máxima permitida por la ley.</p>
        <p>7.3 Responsabilidad máxima: La responsabilidad total de NTLINK, ya sea por contrato, agravio (incluyendo
            negligencia) u otra teoría legal, estará limitada al monto total que el usuario registrado haya pagado a
            NTLINK, si corresponde, durante los últimos 12 meses anteriores al evento que dio lugar a la
            responsabilidad.</p>
        <p>NTLINK no será responsable por el incumplimiento de sus obligaciones contractuales cuando esto se deba a
            causas de fuerza mayor o caso fortuito, incluyendo, sin limitarse a, fallas en los sistemas del SAT,
            desastres naturales, conflictos laborales o actos de autoridad.</p>
    </div>

    <div class="section">
        <h3>Parte 8: Confidencialidad</h3>
        <p>8.1 Información confidencial: Durante la vigencia de este Contrato, el usuario registrado podrá tener acceso
            a información confidencial de NTLINK, la cual incluye, pero no se limita a, datos técnicos, comerciales,
            financieros y estratégicos. El usuario registrado se compromete a mantener la confidencialidad de dicha
            información y a no divulgarla a terceros sin el consentimiento previo y por escrito de NTLINK.</p>
        <p>8.2 Uso de la información confidencial: El usuario registrado utilizará la información confidencial de NTLINK
            únicamente para los fines establecidos en este Contrato y no la utilizará para su propio beneficio o el
            beneficio de terceros sin autorización expresa de NTLINK.</p>
        <p>8.3 Excepciones: La obligación de confidencialidad establecida en este Contrato no se aplicará a la
            información que:</p>
        <p>(a) sea de conocimiento público o que llegue al dominio público sin culpa del usuario registrado;</p>
        <p>(b) sea obtenida de fuentes legítimas que no estén sujetas a obligaciones de confidencialidad;</p>
        <p>(c) deba ser revelada de acuerdo con una orden judicial o requerimiento legal, siempre y cuando el usuario
            registrado haya notificado previamente a NTLINK sobre dicha orden o requerimiento y haya tomado medidas
            razonables para limitar la divulgación de la información confidencial.</p>
        <p>8.4 Vigencia post-terminación: La obligación de confidencialidad establecida en este Contrato continuará
            vigente incluso después de la terminación de este Contrato, sin limitación de tiempo, salvo que se acuerde
            expresamente lo contrario por escrito entre las partes.</p>
    </div>

    <div class="section">
        <h3>Parte 9: Vigencia y terminación</h3>
        <p>9.1 Vigencia: Este Contrato entrará en vigor a partir de la fecha en que el usuario registrado acepte los
            términos y condiciones aquí establecidos, y tendrá una duración de 12 meses a partir de dicha fecha.</p>
        <p>9.2 Renovación automática: En caso de que el usuario registrado no notifique su intención de no renovar este
            Contrato al menos 60 días antes de la fecha de vencimiento, este Contrato se renovará automáticamente por un
            período adicional de 12 meses.</p>
        <p>9.3 Terminación anticipada: Cualquiera de las partes podrá dar por terminado este Contrato antes de su
            vencimiento mediante notificación por escrito a la otra parte con al menos 60 días de anticipación. En caso
            de que el usuario registrado decida terminar este Contrato de manera anticipada, estará sujeto a una
            penalización equivalente a 3 meses de facturación.</p>
        <p>9.4 Efectos de la terminación: En caso de terminación de este Contrato, el usuario registrado perderá el
            acceso al Portal NTLINK y todas las funcionalidades asociadas. NTLINK se reserva el derecho de eliminar o
            retener cualquier información o datos relacionados con la cuenta del usuario registrado después de la
            terminación.</p>
    </div>

    <div class="section">
        <h3>Parte 10: Legislación aplicable y jurisdicción</h3>
        <p>10.1 Legislación aplicable: Este Contrato se regirá e interpretará de acuerdo con las leyes vigentes en
            México, sin tener en cuenta sus principios de conflicto de leyes.</p>
        <p>10.2 Jurisdicción: Cualquier controversia o disputa derivada de este Contrato o relacionada con el mismo,
            incluyendo su existencia, validez, interpretación, cumplimiento o terminación, será sometida a la
            jurisdicción exclusiva de los tribunales competentes de la Ciudad de México, renunciando expresamente a
            cualquier otro fuero que pudiera corresponderles.</p>
        <p>10.3 Idioma: Este Contrato se ha redactado en idioma español. En caso de discrepancia entre la versión en
            español y cualquier traducción, prevalecerá la versión en español.</p>
        <p>Las partes acuerdan someterse a las disposiciones de este apartado y reconocen su validez y vinculación
            legal.</p>
    </div>

    <div class="section">
        <h3>Parte 11: Modificaciones al contrato</h3>
        <p>11.1 Modificaciones: Cualquier modificación o enmienda a este Contrato deberá ser realizada por escrito y
            contar con el consentimiento mutuo de ambas partes. Dichas modificaciones entrarán en vigor únicamente si
            son firmadas por representantes autorizados de NTLINK y el usuario registrado.</p>
        <p>11.2 Comunicación de modificaciones: En caso de realizar modificaciones al Contrato, NTLINK notificará al
            usuario registrado sobre dichas modificaciones por medio de una comunicación escrita enviada al correo
            electrónico registrado por el usuario o a través de un aviso dentro del Portal NTLINK. El usuario registrado
            será responsable de revisar regularmente las notificaciones enviadas por NTLINK y de informarse sobre
            cualquier modificación al Contrato.</p>
        <p>11.3 Aceptación de las modificaciones: El uso continuado del Portal NTLINK por parte del usuario registrado
            después de la implementación de las modificaciones se considerará como una aceptación de dichas
            modificaciones. En caso de que el usuario registrado no esté de acuerdo con las modificaciones, podrá dar
            por terminado este Contrato de conformidad con las disposiciones establecidas en la Parte 9.</p>
    </div>

    <div class="section">
        <h3>Parte 12: Disposiciones generales</h3>
        <p>12.1 Independencia de las partes: Nada en este Contrato creará una relación de sociedad, joint venture,
            empleo o agencia entre NTLINK y el usuario registrado. Cada parte actúa de manera independiente y asume la
            responsabilidad exclusiva de sus propias acciones y obligaciones.</p>
        <p>12.2 Cesión: El usuario registrado no podrá ceder, transferir o sublicenciar sus derechos u obligaciones
            derivados de este Contrato sin el consentimiento previo y por escrito de NTLINK. NTLINK podrá ceder,
            transferir o sublicenciar este Contrato total o parcialmente sin necesidad de obtener el consentimiento del
            usuario registrado.</p>
        <p>12.3 Renuncia: La falta de ejercicio o aplicación por parte de NTLINK de cualquier derecho o disposición de
            este Contrato no constituirá una renuncia a dicho derecho o disposición. Cualquier renuncia a un derecho o
            disposición específica deberá ser realizada por escrito y firmada por un representante autorizado de NTLINK.
        </p>
        <p>12.4 Divisibilidad: Si alguna disposición de este Contrato es considerada inválida, ilegal o inaplicable por
            cualquier motivo, dicha disposición será separada del resto del Contrato y no afectará la validez, legalidad
            y aplicabilidad de las demás disposiciones.</p>
        <p>12.5 Integridad del Contrato: Este Contrato constituye el acuerdo completo y final entre NTLINK y el usuario
            registrado con respecto al objeto aquí estipulado, y reemplaza cualquier acuerdo o entendimiento previo, ya
            sea verbal o escrito, relacionado con dicho objeto.</p>
        <p>12.6 Idioma: Este Contrato se ha redactado en idioma español. En caso de discrepancia entre la versión en
            español y cualquier traducción, prevalecerá la versión en español.</p>
        <p>Las partes declaran y aceptan que han leído, comprendido y aceptado todas las disposiciones de este Contrato,
            y lo firman de mutuo acuerdo.</p>
    </div>

    <div class="section">
        <h3>Parte 13: Firma electrónica</h3>
        <p>13.1 Aceptación electrónica: El usuario registrado reconoce y acepta que la aceptación de este Contrato puede
            ser realizada de manera electrónica a través del Portal NTLINK. Al hacer clic en el botón de aceptación o
            realizar cualquier acción que implique la aceptación de este Contrato, el usuario registrado manifiesta su
            consentimiento y aceptación de todas las disposiciones aquí contenidas.</p>
        <p>13.2 Efecto legal: La firma electrónica del usuario registrado tiene el mismo valor legal que una firma
            manuscrita. Ambas partes acuerdan que este Contrato, incluida la aceptación electrónica, es vinculante y
            tiene plena fuerza y efecto legal.</p>
    </div>

    <div class="section">
        <h3>Parte 14: Notificaciones</h3>
        <p>14.1 Notificaciones electrónicas: El usuario registrado acepta que todas las comunicaciones, notificaciones y
            avisos relacionados con este Contrato podrán ser realizados de manera electrónica a través del Portal NTLINK
            o por correo electrónico a la dirección proporcionada por el usuario registrado al momento de su registro.
        </p>
        <p>14.2 Comunicaciones válidas: Todas las comunicaciones, notificaciones y avisos realizados de conformidad con
            esta Parte se considerarán válidos y vinculantes para ambas partes, incluso si no se entregan físicamente o
            se reciben de manera efectiva.</p>
        <p>14.3 Cambio de dirección de correo electrónico: El usuario registrado será responsable de mantener
            actualizada su dirección de correo electrónico registrada en el Portal NTLINK. Cualquier cambio en la
            dirección de correo electrónico deberá ser notificado a NTLINK de manera oportuna.</p>
    </div>

    <div class="section">
        <h3>Parte 15: Acuerdo completo</h3>
        <p>15.1 Acuerdo completo: Este Contrato, junto con sus anexos y cualquier documento incorporado por referencia,
            constituye el acuerdo completo entre NTLINK y el usuario registrado con respecto al objeto aquí estipulado.
            Cualquier representación, garantía, entendimiento o acuerdo previo, ya sea verbal o escrito, que no esté
            expresamente establecido en este Contrato queda sin efecto y no tendrá validez ni fuerza legal.</p>
        <p>15.2 Modificación por escrito: Cualquier modificación o enmienda a este Contrato deberá ser realizada por
            escrito y firmada por ambas partes para tener validez y efecto legal.</p>
        <p>Ambas partes declaran que han leído, entendido y aceptado todas las disposiciones de este Contrato, y lo
            firman de mutuo acuerdo.</p>
        <p>Este Contrato de uso del Portal NTLINK entra en vigor a partir de la fecha en que el usuario registrado
            acepte electrónicamente los términos y condiciones aquí establecidos.</p>
    </div>

</mat-dialog-content>
<mat-dialog-actions class="flex-column align-center p-4">
    <h6 class="mb-3 text-center">¿Esta de acuerdo con el Contrato mas los Términos de Uso?</h6>
    <div class="d-flex justify-center gap-3">
        <button (click)="cancel()" mat-stroked-button style="color: rgb(232, 116, 116);" [mat-dialog-close]="true">
            No acepto los términos
        </button>
        <button (click)="accept()" mat-stroked-button [mat-dialog-close]="true">
            Si estoy de acuerdo
        </button>
    </div>
</mat-dialog-actions>